module.exports = __webpack_public_path__ + "static/media/logo-trendy.b909dd9e.png";